import apiHandler from "../core/apiHandler";

const cashSessionApi = apiHandler("cash/sessions");

export default cashSessionApi;